import Renderer from "@frog/source/utility/gl/render.js"

const GRADIENT_MAX_NUMBER_OF_STOPS = 15
const palettes = {
    "red": {
        "colors": [
            {
                "r": 128,
                "g": 160,
                "b": 128,
            },
            {
                "r": 104,
                "g": 72,
                "b": 96
            },
            {
                "r": 192,
                "g": 168,
                "b": 184
            },
            {
                "r": 224,
                "g": 224,
                "b": 224
            },
            {
                "r": 112,
                "g": 96,
                "b": 96
            },
            {
                "r": 176,
                "g": 144,
                "b": 88
            },
            {
                "r": 248,
                "g": 248,
                "b": 208
            },
            {
                "r": 96,
                "g": 40,
                "b": 32
            },
            {
                "r": 168,
                "g": 48,
                "b": 40
            },
            {
                "r": 224,
                "g": 16,
                "b": 16
            },
            {
                "r": 248,
                "g": 80,
                "b": 72
            },
            {
                "r": 56,
                "g": 208,
                "b": 48
            },
            {
                "r": 248,
                "g": 248,
                "b": 64
            },
            {
                "r": 128,
                "g": 136,
                "b": 112
            },
            {
                "r": 248,
                "g": 248,
                "b": 248
            },
            {
                "r": 64,
                "g": 56,
                "b": 56
            }
        ]
    },
    "blue": {
        "colors": [
            {
                "r": 128,
                "g": 160,
                "b": 128,
                "a": 0
            },
            {
                "r": 88,
                "g": 72,
                "b": 120
            },
            {
                "r": 144,
                "g": 184,
                "b": 232
            },
            {
                "r": 216,
                "g": 232,
                "b": 240
            },
            {
                "r": 112,
                "g": 96,
                "b": 96
            },
            {
                "r": 176,
                "g": 144,
                "b": 88
            },
            {
                "r": 248,
                "g": 248,
                "b": 208
            },
            {
                "r": 56,
                "g": 56,
                "b": 144
            },
            {
                "r": 56,
                "g": 80,
                "b": 224
            },
            {
                "r": 40,
                "g": 160,
                "b": 248
            },
            {
                "r": 24,
                "g": 240,
                "b": 248
            },
            {
                "r": 232,
                "g": 16,
                "b": 24
            },
            {
                "r": 248,
                "g": 248,
                "b": 64
            },
            {
                "r": 128,
                "g": 136,
                "b": 112
            },
            {
                "r": 248,
                "g": 248,
                "b": 248
            },
            {
                "r": 64,
                "g": 56,
                "b": 56
            }
        ]
    }
}
Object.keys(palettes).forEach((paletteKey) => {
    const palette = palettes[paletteKey]
    palette.colors.forEach((color) => {
        color.L = getLightness(color)
    })
    palette.colors.sort((a, b) => a.L - b.L)
})

function getLightness(color) {
    return (Math.max(color.r, color.g, color.b) + Math.min(color.r, color.g, color.b)) / (255 * 2)
}

// function areSameColor(a, b) {
//     return a.r == b.r
//         && a.g == b.g
//         && a.b == b.b
// }

// function getColorAtIndex(array, index) {
//     return {
//         "r": array[index + 0],
//         "g": array[index + 1],
//         "b": array[index + 2],
//         "a": array[index + 3],
//     }
// }

// function setColorAtIndex(array, index, color) {
//     array[index + 0] = color.r ?? 0
//     array[index + 1] = color.g ?? 0
//     array[index + 2] = color.b ?? 0
//     array[index + 3] = color.a ?? 255
// }

export default function PaletteSwapped({imageElement, paletteKey, colors}) {
    const canvasGL = document.createElement("canvas")
    canvasGL.context = canvasGL.getContext("webgl2")
    canvasGL.context.canvas.width = imageElement.width
    canvasGL.context.canvas.height = imageElement.height
    renderer = new Renderer(canvasGL, "swapper")

    if(imageElement == undefined) return undefined
    if(imageElement.isLoaded != true) return undefined

    if(colors == undefined && paletteKey == undefined) return undefined
    if(paletteKey != undefined && palettes[paletteKey] == undefined) return undefined
    const palette = {}
    if(paletteKey != undefined) {
        palette.colors = palettes[paletteKey].colors
    }
    if(colors != undefined) {
        colors.forEach((color) => {
            color.L = getLightness(color)
        })
        colors.sort((a, b) => a.L - b.L)
        palette.colors = colors
    }
    if(palette.colors.length > GRADIENT_MAX_NUMBER_OF_STOPS) palette.colors = palette.colors.slice(0, GRADIENT_MAX_NUMBER_OF_STOPS)

    renderer.clear()
    renderer.processImageIntoTexture(imageElement)
    renderer.render({
        "image": imageElement,
        "gradientMapping": {
            "colors": palette.colors.map((color) => [color.r, color.g, color.b]),
        },
        "bounds": {
            "x1": 0,
            "y1": 0,
            "x2": imageElement.width,
            "y2": imageElement.height,
        }
    })
    renderer.drawImage({
        "image": imageElement,
        "destination": {
            "x": 0,
            "y": 0,
        }
    })

    return canvasGL.toDataURL()
}
